import PropTypes from 'prop-types'
import styled from 'styled-components'

import { colors } from '../../constants'
import { mediaQuery, mediaQueryForBigger } from '../utils'

const mainColor = colors.bluedark

const Tooltip = styled.div`
    position: relative;
    display: inline-block;
`

const Tiptext = styled.div`
    background: ${mainColor};
    border-radius: 5px;
    color: #fff;
    box-shadow: 0 0 4px #0003;
    text-align: center;
    transition: opacity 0.3s;
    z-index: 1;
    width: 100%;

    ${({ position }) => {
        switch (position) {
            case 'top':
                return `
            bottom: 100%;
            left: 50%; 
            margin-bottom: 10px;
            transform: translateX(-50%);

            &::after {
              top: 100%;
              left: calc(50% - 5px);
              border-width: 5px;
              border-style: solid;
              border-color: ${mainColor} transparent transparent transparent;
            }
          `
            case 'right':
                return `
            top: 50%;
            left: 100%;
            margin-left: 10px;
            transform: translateY(-50%);

            &::after {
              top: calc(50% - 5px);
              right: 100%;
              border-width: 5px;
              border-style: solid;
              border-color: transparent ${mainColor} transparent transparent;
            }
          `
            case 'bottom':
                return `
            top: 100%;
            left: 50%; 
            margin-top: 10px;
            transform: translateX(-50%);

            &::after {
              bottom: 100%;
              left: calc(50% - 5px);
              border-width: 5px;
              border-style: solid;
              border-color: transparent transparent ${mainColor} transparent;
            }
          `
            case 'left':
                return `
            top: 50%;
            right: 100%;
            margin-right: 10px;
            transform: translateY(-50%);

            &::after {
              top: calc(50% - 5px);
              left: 100%;
              border-width: 5px;
              border-style: solid;
              border-color: transparent transparent transparent ${mainColor};
            }
          `
            case 'mobile':
                return `
            margin-right: 10px;
          `
            default:
                return null
        }
    }}

    ${mediaQuery.mobile(`
  `)}

  ${mediaQueryForBigger.mobile(`
    position: absolute;
    padding: 10px;
    opacity: 0;
    &::after {
      content: ' ';
      position: absolute;
    }
    div:focus > &,
    div:hover > &,
    &:focus,
    &:hover {
      opacity: 1;
    }
  `)}
`

Tiptext.propTypes = {
    position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
}

Tiptext.defaultProps = {
    position: 'bottom',
}

export { Tiptext }

export default Tooltip
